export default __webpack_public_path__ + "static/media/icon-duza ilosc energii.73b01f2d.svg";